import { render, staticRenderFns } from "./LayoutSelector.vue?vue&type=template&id=b3a6111c&scoped=true&"
import script from "./LayoutSelector.vue?vue&type=script&lang=js&"
export * from "./LayoutSelector.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSelector.vue?vue&type=style&index=0&id=b3a6111c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a6111c",
  null
  
)

export default component.exports